import React from 'react'
import { cn } from 'oddle-shop-monorepo.design-system'

type BaseProps = {
  children: React.ReactNode
  className?: string
  ref?: React.Ref<HTMLDivElement>
  style?: React.CSSProperties
}

const Container = ({ children, className = '', ref }: BaseProps) => (
  <div
    className={cn(
      'px-2 md:mx-auto md:max-w-[calc(100vw-16px)] md:px-2 lg:max-w-[1200px] lg:px-4',
      className,
    )}
    ref={ref}
  >
    {children}
  </div>
)

const Section = ({ children, className = '', style }: BaseProps) => (
  <div className={cn('my-6 block w-full', className)} style={style}>
    {children}
  </div>
)

// Create the compound component
const ResponsiveSection = Object.assign(Section, {
  Container,
})

export default ResponsiveSection
